import { Category, GradeLevel, Platform, Technology } from 'models';
import * as Yup from 'yup';

export const getLessonSchema = (lessonFile?: File) =>
  Yup.object()
    .shape({
      basicInfo: Yup.object()
        .shape({
          lesson: Yup.object()
            .shape({
              title: Yup.string().required('Please enter a lesson title.'),
              description: Yup.string().required('Please enter a description.'),
            })
            .defined(),
          gradeLevels: Yup.array()
            .of(Yup.string().oneOf(Object.values(GradeLevel)).defined())
            .min(1, 'Please add one or more grade levels.')
            .defined(),
          cstaStandards: Yup.string()
            .matches(/(\d[A-Za-z]-[A-Za-z][A-Za-z]-\d\d(,)?( )?)+/, 'Enter a valid standard. Standards must follow the format XX-XX-XX. Use a comma to separate multiple standards.')
        })
        .defined(),
      techRequirements: Yup.object()
        .shape({
          technologies: Yup.array()
            .of(Yup.string().oneOf(Object.values(Technology)).defined()),
          categories: Yup.array()
            .of(Yup.string().oneOf(Object.values(Category)).defined()),
          platforms: Yup.array()
            .of(Yup.string().oneOf(Object.values(Platform)).defined())
        })
        .defined(),
      subjectAreas: Yup.array()
        .of(
          Yup.object()
            .shape({
              subject: Yup.string().required('Please select a subject.'),
              contentStrands: Yup.array().of(Yup.string().defined()),
              mnStandards: Yup.string(),
            })
            .defined(),
        )
        .min(1, 'Please add one or more subject areas.')
        .defined(),
      upload: Yup.string()
        .required('Please upload a lesson.')
        .test(
          'less-than-10mb',
          'Please select a file smaller than 10MB.',
          () => (lessonFile?.size ?? 0) < 10000000,
        ),
      personalInformation: Yup.object()
        .shape({
          name: Yup.string().required('Please enter a first and last name.'),
          email: Yup.string()
            .email('Please enter a valid email address.')
            .required('Please enter an email address.'),
          twitter: Yup.string(),
          school: Yup.object()
          .shape({
            name: Yup.string(),
            district: Yup.string(),
            zip: Yup.number()
              .typeError('Please enter a valid 5-digit numeric zip code.')
              .test('length', 'Please enter a valid 5-digit zip code.', (value: number) => !value || value.toString().length === 5),
            state: Yup.string(),
          }).defined(),
          displayInfo: Yup.boolean().required('Please make a selection.'),
        })
        .defined(),
      permissions: Yup.object()
        .shape({
          allResourcesLicensed: Yup.boolean()
            .test('isTrue', 'You must agree to the conditions.', (value: boolean) => value)
            .defined(),
          permissionGranted: Yup.boolean()
            .test('isTrue', 'You must agree to the conditions.', (value: boolean) => value)
            .defined(),
        })
        .defined(),
    })
    .defined();
